import { getCookies } from 'cookies-next'
import { ChangeEventHandler, useId, useState } from 'react'
import { PATHS } from '@/fractals/constants'
import { margetingLead } from '@/modules/shared/widgets/LeadForm/LeadForm'
import { $api } from '~shared/api/$api'
import { ArrowUpIcon } from '~shared/icons/arrow-up'
import { cn } from '~shared/utils/cn'
import { isEmail } from '~shared/utils/isEmail'

const Message = ({
  severity,
  content
}: {
  severity: string
  content: string
}) => (
  <span
    className={cn('', {
      'text-danger': severity === 'error',
      'text-success': severity === 'success'
    })}>
    {content}
  </span>
)

export const SubscriberForm = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState<{
    severity: string
    content: string
  } | null>(null)

  const [isLoading, setIsLoading] = useState(false)

  const formTitleId = useId()

  const registerLead = () => {
    const cookies = getCookies()

    margetingLead({
      event: 'getmail',
      program: null,
      googleClientId: cookies.gclUid || null,
      email
    })
  }

  const handleSubmit = () => {
    if (!isEmail(email)) {
      setMessage({ severity: 'error', content: 'Некорректный email' })
      return
    }

    registerLead()

    setIsLoading(true)

    try {
      $api.post(`${PATHS.front.api.lead.index}`, {
        email,
        subscribe: 'Да'
      })

      setMessage({ severity: 'success', content: 'Спасибо за подписку!' })
    } catch (e: unknown) {
      setMessage({ severity: 'error', content: 'Ошибка' })
    }

    setIsLoading(false)
  }

  const handleEmailChange: ChangeEventHandler<HTMLInputElement> = e => {
    setEmail(e.target.value)
    setMessage(null)
  }

  return (
    <div>
      <p id={formTitleId} className='font-medium text-[20px] text-accent'>
        Подписаться на обновления
      </p>

      <form
        aria-labelledby={formTitleId}
        className='flex flex-col gap-4 mt-[24px] lg-[32px]'
        onSubmit={e => {
          e.preventDefault()
          handleSubmit()
        }}>
        <p className='text-primary'>Ваш Email</p>
        <div className='relative w-full lg:w-[488px]'>
          <input
            type='email'
            name='email'
            className='pl-4 font-semibold text-[14px] h-12 rounded-[8px] w-full placeholder:text-input-placeholder'
            placeholder='Введите вашу почту'
            onChange={handleEmailChange}
            value={email}
          />
          <button
            type='submit'
            aria-label='Отправить email'
            disabled={isLoading}
            className='hover:bg-tertiary transition-colors duration-300 size-10 bg-accent text-primary absolute right-1 top-1 rounded-[8px] flex items-center justify-center'>
            <ArrowUpIcon className='rotate-45' />
          </button>
          {!!message && <Message {...message} />}
        </div>
      </form>
    </div>
  )
}
